import React from 'react';
import {FieldViewSmallProps} from "../../../render/view-small";

export default function FieldString_ViewSmall(props:FieldViewSmallProps) {

    // const value = _.get(props.model, props.field.fieldId, null)
    const value = props.field.getViewValue(props.model)

    const classes = Classes("ui5-txt-less-important-small", "txt-truncate", props.className, {
        'invalid-value': !props.field.isValueValid(value)
    })

    return (
        <div className={classes}>
            {!_.isNil(value) && _.get(props.field.components, 'ValuePrefix', false)}
            {props.field.getDisplayValue(value)}
        </div>
    );
}
